'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var edgeStyle_model = require('./edge-style.model.js');
var vertexStyle_model = require('./vertex-style.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);

/**
 * Graph style representation in database.
 *
 * @export
 * @interface DBGraphStyleJson
 */

/**
 * GraphStyle describes the style of a graph, including the style of it's vertex
 * types and edge types.
 *
 * @export
 * @class GraphStyle
 */
var GraphStyle = /*#__PURE__*/function () {
  /**
   * Creates an instance of GraphStyle.
   *
   * @memberof GraphStyle
   */
  function GraphStyle() {
    _classCallCheck__default["default"](this, GraphStyle);
    this.vertexStyles = new _Map__default["default"]();
    this.edgeStyles = new _Map__default["default"]();
  }

  /**
   * Set properties from DB graph style json.
   *
   * @param {DBGraphStyleJson} graphStyle
   * @returns {GraphStyle}
   * @memberof GraphStyle
   */
  return _createClass__default["default"](GraphStyle, [{
    key: "loadFromDBJson",
    value: function loadFromDBJson(graphStyle) {
      var _context,
        _this = this,
        _context2;
      _forEachInstanceProperty__default["default"](_context = _Object$keys__default["default"](graphStyle.vertexStyles)).call(_context, function (name) {
        var vStyleJson = graphStyle.vertexStyles[name];
        var vStyle = new vertexStyle_model.VertexStyle();
        vStyle.loadFromDBJson(vStyleJson);
        _this.vertexStyles.set(name, vStyle);
      });
      _forEachInstanceProperty__default["default"](_context2 = _Object$keys__default["default"](graphStyle.edgeStyles)).call(_context2, function (name) {
        var eStyleJson = graphStyle.edgeStyles[name];
        var eStyle = new edgeStyle_model.EdgeStyle();
        eStyle.loadFromDBJson(eStyleJson);
        _this.edgeStyles.set(name, eStyle);
      });
      return this;
    }

    /**
     * Dump GraphStyle into DB graph style json representation.
     *
     * @returns {DBGraphStyleJson}
     * @memberof GraphStyle
     */
  }, {
    key: "dumpToDBJson",
    value: function dumpToDBJson() {
      var _context3, _context4;
      var vStyles = {};
      var eStyles = {};
      _forEachInstanceProperty__default["default"](_context3 = this.vertexStyles).call(_context3, function (vStyle, name) {
        vStyles[name] = vStyle.dumpToDBJson();
      });
      _forEachInstanceProperty__default["default"](_context4 = this.edgeStyles).call(_context4, function (eStyle, name) {
        eStyles[name] = eStyle.dumpToDBJson();
      });
      return {
        vertexStyles: vStyles,
        edgeStyles: eStyles
      };
    }
  }]);
}();

exports.GraphStyle = GraphStyle;
